var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appBody min-vh-100 bg-grey-light"},[_c('little-header'),_c('no-data',{attrs:{"text":_vm.tipTxt}}),_c('little-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }